import engineer from "../assets/engineer.jpg";
import miningIndustry from "../assets/mining-indust.webp";
import industrialScene from "../assets/indust.jpg";
import refinery from "../assets/refinery.jpg";
import refinerySupport from "../assets/refinery.png";
import vlc from "../assets/vlc.webp";
import freight from "../assets/freight.jpg";
import trade from "../assets/trade.png";
import goldMine from "../assets/Gold-Mine.jpeg";
import landing from "../assets/landing.png";
import gary from "../assets/gary.jpg";
import faisal from "../assets/faisal.webp";
import avatar from "../assets/ali-ab.jpg";
import ares from "../assets/ares.webp";
import cedg from "../assets/cedg.png";
import logo1 from "../assets/Logo_InPixio-2.png";
import logo2 from "../assets/IMEX-Logo.svg";
import logo3 from "../assets/logo.gif";

export const siteMeta = {
  name: "Refwa",
  projectName: "Refwa for Mining",
  tagline:
    "Mining, petroleum services, trade, construction, and industrial support.",
  shortDescription:
    "Refwa operates across mining, petroleum services, international trade, construction, industrial support, environmental services, heavy equipment, and sustainability solutions.",
  email: "info@refwa.com",
  officeHours: "Office hours 09:00 am - 05:00 pm",
  address: "115 Kelly St. Yorktown VA 23690",
  regions: ["Europe", "USA", "China", "Middle East"],
  heroImage: landing,
  bannerImage: goldMine,
};

export const navigationLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Articles", to: "/articles" },
  { label: "Team", to: "/team" },
  { label: "Contact", to: "/contact" },
];

export const stats = [
  {
    value: "18+",
    label: "Years of sector experience referenced",
  },
  {
    value: "3",
    label: "Core business lines",
  },
  {
    value: "6",
    label: "Operating capability areas",
  },
  {
    value: "4",
    label: "Referenced trade regions",
  },
];

export const aboutHighlights = [
  {
    title: "Established operations",
    description:
      "Refwa reflects long-standing experience across mining and international trade, supported by regional knowledge and long-term commercial relationships.",
  },
  {
    title: "Operating range",
    description:
      "Refwa's operations extend across mining, petroleum services, trade, construction support, industrial operations, and sustainability-related services.",
  },
  {
    title: "Regional reach",
    description:
      "Refwa's commercial reach extends across Europe, the USA, China, and the Middle East.",
  },
];

export const companyNarrative = {
  overview:
    "Refwa is an international business group active across mining, petroleum services, and international trade, with related capabilities in construction, industrial delivery, environmental rehabilitation, facility support, equipment-backed execution, and water and sustainability initiatives.",
  body: [
    "Refwa USA is a well-established company with over 18 years of experience in the mining and international trade sectors. Its business is grounded in trusted relationships, regional expertise, and the capacity to support clients across multiple markets.",
    "Refwa's wider operating interests extend across concrete works, civil construction, heavy equipment support, government contracting support, environmental remediation, facility operations, workforce support, and sustainability-linked water solutions.",
    "This breadth positions Refwa as a multi-capability industrial and project support group able to contribute across resource development, site execution, industrial delivery, and operational support.",
  ],
  mission:
    "To provide dependable mining, petroleum, trade, and project support services through practical execution, sound coordination, and long-term commercial relationships.",
  vision:
    "To be recognized as a trusted industrial and infrastructure partner across resource development, construction delivery, operational support, and sustainable growth.",
  values: [
    "Operational reliability",
    "Strategic partnership",
    "Responsible growth",
    "International collaboration",
  ],
};

export const serviceCards = [
  {
    id: "mining",
    title: "Mining",
    description:
      "Mining services covering surface and underground operations, artisanal mining context, and related project support requirements.",
    image: miningIndustry,
    to: "/services/mining",
  },
  {
    id: "petroleum-services",
    title: "Petroleum Services",
    description:
      "Petroleum services focused on refinery operations, logistics, operational readiness, and energy-sector project support.",
    image: refinerySupport,
    to: "/services/petroleum-services",
  },
  {
    id: "international-trade",
    title: "International Trade",
    description:
      "Trade services covering sourcing, logistics coordination, import-export relationships, and cross-border commercial activity.",
    image: trade,
    to: "/services/international-trade",
  },
  {
    id: "construction-industrial",
    title: "Construction and Industrial Works",
    description:
      "Construction and industrial works covering infrastructure support, civil works, foundations, slabs, site preparation, and project delivery.",
    image: industrialScene,
    to: "/portfolio",
  },
  {
    id: "equipment-support",
    title: "Heavy Equipment and Earthworks Support",
    description:
      "Heavy equipment and earthworks support for site preparation, excavation, backfilling, leveling, and construction operations.",
    image: engineer,
    to: "/portfolio",
  },
  {
    id: "sustainability",
    title: "Sustainability & Water",
    description:
      "Water services, environmental support, and sustainability-related operating solutions for industrial and infrastructure projects.",
    image: goldMine,
    to: "/portfolio",
  },
];

export const mediaCards = [
  {
    id: "media-mining",
    title: "Mining",
    description:
      "Mining services include surface and underground operations, resource support, and related project execution.",
    image: miningIndustry,
    linkLabel: "Explore Mining",
    to: "/services/mining",
  },
  {
    id: "media-petroleum",
    title: "Petroleum Services",
    description:
      "Petroleum services cover refinery support, logistics, and industrial coordination in energy-sector environments.",
    image: refinery,
    linkLabel: "Explore Petroleum",
    to: "/services/petroleum-services",
  },
  {
    id: "media-trade",
    title: "International Trade",
    description:
      "International trade services support sourcing, commercial coordination, import-export activity, and regional supply movement.",
    image: freight,
    linkLabel: "Explore Trade",
    to: "/services/international-trade",
  },
];

export const serviceDetails = {
  mining: {
    id: "mining",
    slug: "mining",
    title: "Mining",
    eyebrow: "Core Service",
    heroImage: miningIndustry,
    sideImage: industrialScene,
    intro:
      "Mining remains one of Refwa's core business lines, supported by practical sector knowledge across resource development and extraction environments.",
    paragraphs: [
      "Mining involves the extraction of minerals from seams, veins, reefs, lodes, and placer deposits. Refwa's scope references coal, metals, oil shale, rock salt, potash, gemstones, limestone, clay, chalk, stone, and gravel among the materials associated with mining activity.",
      "Refwa's mining scope recognizes both surface and underground operations while also acknowledging artisanal mining within the wider sector.",
      "Mining services are presented through sector familiarity, project support, infrastructure readiness, equipment coordination, and industrial execution.",
    ],
    keyPoints: [
      "Surface mining support",
      "Underground mining support",
      "Artisanal mining sector awareness",
      "Industrial support for mining operations",
    ],
    supportAreas: [
      "Site preparation and infrastructure support",
      "Equipment and logistics coordination",
      "Industrial services aligned with project delivery",
      "Partnership-driven support across mining value chains",
    ],
  },
  "petroleum-services": {
    id: "petroleum-services",
    slug: "petroleum-services",
    title: "Petroleum Services",
    eyebrow: "Core Service",
    heroImage: refinery,
    sideImage: vlc,
    intro:
      "Petroleum services form part of Refwa's operating scope, with emphasis on refinery environments, petroleum handling, and industrial project support.",
    paragraphs: [
      "Petroleum refineries convert crude oil into products used for transportation, heating, paving roads, electricity generation, and chemical feedstocks.",
      "Refwa's petroleum services are framed around industrial coordination, infrastructure readiness, logistics, and project execution in refinery and petroleum service environments.",
      "The refinery process is considered through separation, conversion, and treatment, alongside broader industrial and operational support.",
    ],
    keyPoints: [
      "Separation",
      "Conversion",
      "Treatment",
      "Industrial and operational support around petroleum environments",
    ],
    supportAreas: [
      "Refinery-adjacent site support",
      "Facility readiness and maintenance coordination",
      "Trade and supply movement support",
      "Construction and industrial project interfaces",
    ],
  },
  "international-trade": {
    id: "international-trade",
    slug: "international-trade",
    title: "International Trade",
    eyebrow: "Core Service",
    heroImage: freight,
    sideImage: trade,
    intro:
      "International trade remains one of Refwa's core business lines and a key link between industrial, commercial, and cross-border operations.",
    paragraphs: [
      "International trade includes commercial activity conducted through imports, exports, goods, services, and capital movement across borders.",
      "Refwa's trade services cover sourcing, logistics coordination, supply movement, and commercial relationships across regions.",
      "The trade business is presented through dependable coordination, market connectivity, and the practical discipline required to move industrial requirements across borders.",
    ],
    keyPoints: [
      "Export trade",
      "Import trade",
      "Entrepot trade",
      "Cross-border sourcing and logistics support",
    ],
    supportAreas: [
      "Commercial relationship management",
      "Industrial procurement support",
      "Regional supply chain coordination",
      "Portfolio-wide trade enablement",
    ],
  },
};

export const supportCapabilities = [
  {
    title: "Infrastructure & Site Works",
    description:
      "Site enabling works, infrastructure support, and construction-readiness activities for industrial and commercial projects.",
  },
  {
    title: "Industrial Civil Works",
    description:
      "Concrete, foundations, slabs, cast-in-place work, tilt-up structures, yards, and civil support for industrial and infrastructure programs.",
  },
  {
    title: "Equipment & Earthworks",
    description:
      "Excavation, backfilling, leveling, site preparation, and equipment support for demanding project environments.",
  },
  {
    title: "Environmental Remediation",
    description:
      "Containment, rehabilitation, cleanup support, and construction-linked remediation services for complex sites.",
  },
  {
    title: "Facilities & Workforce",
    description:
      "Operations support, maintenance, staffing, and facility service coordination for industrial and public-sector work.",
  },
  {
    title: "Sustainability & Water",
    description:
      "Water services, emergency water support, environmental programs, and sustainability-related project initiatives.",
  },
];

export const portfolioCompanies = [
  {
    id: "concrete-civil-construction-support",
    name: "Concrete & Civil Construction Support",
    focus: "Concrete works and civil construction",
    description:
      "Commercial concrete and civil construction capability covering cast-in-place work, tilt-up structures, foundations, industrial slabs, yards, and heavy construction support.",
  },
  {
    id: "heavy-equipment-support",
    name: "Heavy Equipment Support",
    focus: "Heavy equipment rental and support",
    description:
      "Heavy equipment support for site preparation, excavation, backfilling, leveling, earthworks, and construction execution across commercial and public-sector projects.",
  },
  {
    id: "environmental-construction-support",
    name: "Environmental Construction Support",
    focus: "Environmental remediation and construction support",
    description:
      "Environmental rehabilitation, containment, cleanup support, and construction-linked remediation capability for large project environments and site recovery needs.",
  },
  {
    id: "general-contracting-support",
    name: "General Contracting Support",
    focus: "General contracting",
    description:
      "General contracting support covering civil, industrial, facility, maintenance, renovation, and ground-up construction scopes across public and private sector contexts.",
  },
  {
    id: "operations-workforce-support",
    name: "Operations & Workforce Support",
    focus: "Operations, workforce, and facility support",
    description:
      "Workforce deployment, maintenance, facility operations, and program support across construction, operations, and public-sector contract environments.",
  },
  {
    id: "sustainability-support",
    name: "Sustainability Support",
    focus: "Water, sustainability, and environmental support",
    description:
      "Support capability for water solutions, sustainability initiatives, environmental support, and resource-efficiency programs across industrial, infrastructure, and operational environments.",
  },
];

export const projectSupportAreas = [
  "Mining and resource-support environments",
  "Petroleum and refinery-adjacent industrial work",
  "International procurement and trade movement",
  "Concrete, civil, and heavy construction programs",
  "Facility operations and maintenance support",
  "Environmental rehabilitation and sustainability initiatives",
];

export const partnerLogos = [
  {
    id: "partner-cedg",
    name: "CEDG",
    logo: cedg,
    url: "http://cedg-oil.com/",
  },
  {
    id: "partner-ares",
    name: "Ares Global",
    logo: ares,
    url: "https://www.thearesglobal.com/",
  },
  {
    id: "partner-refwa-brand",
    name: "Refwa Brand",
    logo: logo3,
    url: null,
  },
  {
    id: "partner-imex",
    name: "IMEX",
    logo: logo2,
    url: null,
  },
  {
    id: "partner-inpixio",
    name: "Strategic Partner",
    logo: logo1,
    url: null,
  },
];

export const teamMembers = [
  {
    id: "gary-lang",
    name: "Mr. Gary Lang",
    role: "Chief Executive Officer",
    image: gary,
    bio:
      "Chief Executive Officer responsible for executive management and business coordination.",
  },
  {
    id: "ali-bin-haidar",
    name: "Ali Abdullah Bin Haidar",
    role: "Chairman of Bin Haidar Holding Group",
    image: avatar,
    bio:
      "Chairman of Bin Haidar Holding Group, leading the group’s strategy, investments, and partnerships.",
  },
  {
    id: "ahmed-faisal",
    name: "Dr. Ahmed Faisal",
    role: "General Manager",
    image: faisal,
    bio:
      "General Manager responsible for daily operations and business development.",
  },
];

export const contactDetails = [
  {
    title: "Office Location",
    value: siteMeta.address,
    helper: "Main office location.",
  },
  {
    title: "Email",
    value: siteMeta.email,
    helper: siteMeta.officeHours,
  },
  {
    title: "Coverage",
    value: siteMeta.regions.join(" | "),
    helper: "Regional and international coverage.",
  },
];

export const posts = [
  {
    id: "1",
    slug: "exploring-mining-frontiers",
    title: "Mining Frontiers",
    category: "Mining",
    summary:
      "An overview of mining support across extraction environments, industrial readiness, and project execution.",
    body: [
      "Mining remains central to Refwa's business scope and is supported by practical operating capability across extraction environments.",
      "The mining discussion extends beyond extraction terminology to include site readiness, industrial support, practical logistics, and disciplined coordination.",
      "This breadth places mining within a wider business structure that also includes construction, trade, industrial services, and operational support.",
    ],
    cover: engineer,
  },
  {
    id: "2",
    slug: "inside-the-earth-practical-mining-support",
    title: "Practical Mining Support",
    category: "Mining",
    summary:
      "An outline of how infrastructure, equipment, and disciplined operating support strengthen mining work on the ground.",
    body: [
      "Mining support depends on more than field presence. It also requires access works, logistics, equipment, trade movement, and industrial discipline.",
      "Refwa's mining scope is expressed through enabling capability, operating support, and practical coordination across project environments.",
      "This discussion is intended as sector commentary aligned with Refwa's established business lines.",
    ],
    cover: miningIndustry,
  },
  {
    id: "3",
    slug: "international-trade-and-industrial-logistics",
    title: "Trade and Industrial Logistics",
    category: "International Trade",
    summary:
      "A concise view of how trade services support regional supply movement, sourcing relationships, and industrial coordination.",
    body: [
      "International trade connects resources, industrial inputs, and project requirements across borders.",
      "Trade services support procurement, scheduling, commercial relationships, and delivery confidence across operating regions.",
      "Alongside construction support, industrial works, and sustainability-related services, trade forms a core part of Refwa's wider operating capacity.",
    ],
    cover: freight,
  },
];

export const footerLinks = {
  quickLinks: [
    { label: "About", to: "/about" },
    { label: "Services", to: "/services" },
    { label: "Capabilities", to: "/portfolio" },
    { label: "Contact", to: "/contact" },
  ],
  policyLinks: [
    { label: "Privacy & Policy", to: "/contact" },
    { label: "Terms & Conditions", to: "/contact" },
    { label: "Disclaimer", to: "/contact" },
    { label: "FAQ", to: "/articles" },
  ],
};

export const seoContent = {
  home: {
    title: "Refwa | Mining, Petroleum, Trade, and Industrial Services",
    description:
      "Refwa operates across mining, petroleum services, international trade, construction, industrial support, environmental services, and sustainability solutions.",
  },
  about: {
    title: "About Refwa | Industrial and Commercial Group",
    description:
      "Learn how Refwa combines mining, petroleum services, trade, construction, industrial support, and sustainability-related capabilities.",
  },
  services: {
    title: "Services | Refwa",
    description:
      "Explore Refwa's services across mining, petroleum services, international trade, civil works, equipment support, environmental services, and sustainability solutions.",
  },
  portfolio: {
    title: "Portfolio Capabilities | Refwa",
    description:
      "View Refwa's portfolio companies across concrete works, equipment support, environmental services, contracting, facilities, and water solutions.",
  },
  articles: {
    title: "Articles | Refwa Insights",
    description:
      "Read articles on mining, trade, petroleum services, industrial delivery, and project support.",
  },
  contact: {
    title: "Contact | Refwa",
    description:
      "Contact Refwa regarding mining, petroleum services, international trade, construction, and industrial support requirements.",
  },
  team: {
    title: "Leadership and Team | Refwa",
    description: "Leadership and representative roles associated with Refwa.",
  },
  notFound: {
    title: "Page Not Found | Refwa",
    description:
      "The page you are looking for is not available. Return to Refwa or contact the team directly.",
  },
};
